import { Component, OnDestroy, OnInit, signal } from '@angular/core';
import { BannerPromoComponent } from 'src/app/home-page/components/banner-promo/banner-promo.component';
import { PromotionalBannerModel } from 'src/app/home-page/models/promotional-banner.model';
import { PromotionalBannersService } from 'src/app/home-page/services/promotional-banners.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'cgw-primary-banner-section',
  standalone: true,
  imports: [BannerPromoComponent],
  templateUrl: './primary-banner-section.component.html',
  styleUrl: './primary-banner-section.component.scss',
})
export class PrimaryBannerSectionComponent implements OnInit, OnDestroy {
  private readonly _destroyS = new Subject<boolean>();

  public readonly mainBanner = signal<PromotionalBannerModel | null>(null);

  constructor(private _promotionalBannersService: PromotionalBannersService) {}

  public ngOnInit(): void {
    this._promotionalBannersService.mainBanner$
      .pipe(takeUntil(this._destroyS))
      .subscribe((banner) => {
        this.mainBanner.set(banner);
      });
  }

  public ngOnDestroy(): void {
    this._destroyS.next(true);
    this._destroyS.complete();
  }
}
